module.exports = __webpack_public_path__ + "img/google-play-badge-pt.4567953a.png";